
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import Page from "@/src/components/Page";
import PocsShell from "@/src/layouts/PocsShell";

const Pocs = ({}) => {
    return (
        <PocsShell  />
    );
};

const PocsPage = () => (
    <Page name="Pocs" path="/pricing/">
        <Pocs />
    </Page>
);

export default PocsPage;




    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/pocs/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  